import { render, staticRenderFns } from "./resultados.vue?vue&type=template&id=0c0094ea&"
import script from "./resultados.component.ts?vue&type=script&lang=ts&"
export * from "./resultados.component.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports